import { useContext } from "react"
import { Link } from "react-router-dom"

import { HeaderMenuContext } from "areas/header/portal"
import Button from "components/ui/button"
import Media from "components/ui/media"
import { cn } from "styles/utils"

import CountrySelector from "./country-selector"

const MicroBanner = () => {
  const { menu } = useContext(HeaderMenuContext)
  const navBarLinks = menu && menu.navbar_links

  return (
    <Media className="bg-primary" greaterThanOrEqual="desktop">
      <nav
        aria-label="Site Navigation"
        className="contained-wide h-(--micro-banner-height) flex items-center justify-end px-32"
        id="nav-bar"
      >
        {navBarLinks?.length && (
          <ul className="flex list-none items-center" role="menubar">
            {navBarLinks.map((link, i) => (
              <li key={`navbar-item-${i}`} role="none">
                <Button
                  asChild={link.external}
                  className={cn(
                    "text-14 tracking-half focus-visible:outline-secondary mr-32 font-medium capitalize text-white focus-visible:outline-2",
                    link.style?.secondary &&
                      "bg-secondary text-primary h-28 px-12 font-bold uppercase"
                  )}
                  data-lc="navbar"
                  role="menuitem"
                  {...link.style?.className}
                >
                  {link.external ? (
                    <a
                      href={link.url}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link to={link.url}>{link.name}</Link>
                  )}
                </Button>
              </li>
            ))}
          </ul>
        )}
        <CountrySelector />
      </nav>
    </Media>
  )
}

export default MicroBanner
